<tui-elastic-container *transloco="let t">
  <pxc-paywall-alert />
  @if (sequence$ | async; as sequence) {
    <div class="flex flex-col gap-6">
      <section class="flex shrink-0 flex-col gap-2">
        <h6 class="text-lg font-semibold">{{ t('Photos') }}</h6>
        <pxc-image-input
          data-testid="medias"
          ngDefaultControl
          [accept]="dropZoneAcceptValidator()"
          [isLongVideoEnabled]="isLongVideoEnabled()"
          [maxFileSize]="dropZoneMaxFileSize"
          [medias]="medias"
          [showDelete]="medias.length + newMedias.length > 0"
          [(ngModel)]="newMedias"
          (mediaClickedIdx)="openGallery($event)"
          (mediaDelete)="deleteMedia($event)" />
        @if (hasTooLargeImagePayload) {
          <tui-error
            data-testid="image-payload-too-large"
            [error]="t('La taille totale des photos ne peut pas dépasser 1 Go.')" />
        }
        @if (pictureCount === 0) {
          <tui-error
            [error]="
              isLongVideoEnabled()
                ? t('Veuillez ajouter au moins une photo ou une vidéo')
                : t('Veuillez ajouter au moins une photo.')
            " />
        }
      </section>
      @if (!!basePatient && (displayAnalysis$ | async)) {
        <section class="flex flex-col gap-2">
          <h6 class="text-lg font-semibold">{{ t('Lésion') }}</h6>
          <pxc-sadm-analysis-input
            [analysisFormAnswer]="analysisFormAnswer$ | async"
            [clientCode]="clientCode"
            [formInputs]="formInputs"
            [isLoading]="(isSadmFormLoading$ | async) !== false"
            [patientId]="basePatient.id"
            [protocolFormAnswer]="protocolFormAnswer$ | async"
            [(sadmEntityDraft)]="sadmEntityDraft"
            [(sadmEntityId)]="sadmEntityId"
            (analysisFormAnswerChange)="analysisFormAnswer$.next($event)"
            (outputPictures)="onOutputPicturesChange($event)"
            (protocolFormAnswerChange)="protocolFormAnswer$.next($event)" />
        </section>
      }
      <section class="flex flex-col gap-2">
        <h6 class="text-lg font-semibold">{{ t('Patient') }}</h6>
        <pxc-patient-edit
          data-testid="patient-edit"
          [clientCode]="clientCode"
          [displayActionButtons]="false"
          [patient]="updatedPatient"
          (formValidityUpdate)="isPatientEditFormValid$.next($event)"
          (isCheckingFormValidityChange)="isPatientEditFormLoading$.next($event)"
          (patientChange)="patientChange($event)" />
      </section>
      <section class="flex flex-col gap-2">
        <h6 class="text-lg font-semibold">{{ t('Mots clés') }}</h6>
        <pxc-select-label class="select-label" data-testid="labels" [(selectedLabels)]="updatedLabels" />
      </section>
      <section class="flex flex-col gap-2">
        <h6 class="text-lg font-semibold">{{ t('Groupes') }}</h6>
        <pxc-department-picker
          [clientCode]="clientCode"
          [isClientChoiceDisabled]="true"
          [isDepartmentChoiceDisabled]="isDepartmentChoiceDisabled$ | async"
          [(departmentIds)]="selectedDepartmentIds" />
      </section>
      <section class="flex flex-col gap-2">
        <h6 class="text-lg font-semibold">{{ t('Informations') }}</h6>
        <div class="grid gap-6 lg:grid-cols-2">
          <label tuiLabel>
            {{ t('Entrez une date et une heure') }}
            <tui-textfield>
              <input
                data-testid="input-date"
                placeholder="18/04/2019 14:22"
                tuiInputDateTime
                [(ngModel)]="updatedDate" />
              <tui-calendar *tuiDropdown />
            </tui-textfield>
          </label>
        </div>
        <label tuiLabel>
          {{ t('Description') }}
          <tui-textfield>
            <textarea
              data-testid="description"
              maxlength="65535"
              tuiTextarea
              [min]="3"
              [placeholder]="t('Ajoutez une description')"
              [(ngModel)]="updatedDescription"></textarea>
          </tui-textfield>
        </label>
      </section>
      <div class="mt-2 flex flex-wrap items-center justify-between gap-2">
        <button appearance="outline" class="max-md:w-full" tuiButton type="button" (click)="close()">
          {{ t('Annuler') }}
        </button>
        <button
          class="max-md:order-first max-md:w-full"
          data-testid="confirm"
          tuiButton
          type="button"
          [disabled]="canConfirmSequenceEdition(isPatientEditFormValid$ | async, isPatientEditFormLoading$ | async)"
          [loading]="isPatientEditFormLoading$ | async"
          (click)="save()">
          {{ t('Enregistrer') }}
        </button>
      </div>
    </div>
  } @else {
    <div class="flex h-14 flex-col items-center justify-center gap-2">
      <pxc-spinner />
      <p class="text-sm text-text-tertiary">{{ t("Préparation de l'édition ...") }}</p>
    </div>
  }
</tui-elastic-container>
